import React, { useState, useEffect } from 'react';
import axios from 'axios';

const VisaPage = () => {
    // 👇 Updated to Localhost URL
    const API_BASE_URL = "https://backend-new-steel-theta.vercel.app";

    // --- STATES ---
    const [visas, setVisas] = useState([]); // Sara data yahan aayega
    const [loading, setLoading] = useState(true); // Loading state
    const [searchTerm, setSearchTerm] = useState(''); // Search ke liye

    // --- FETCH DATA FROM MONGODB ---
    const fetchVisas = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/api/visa`);
            setVisas(res.data); // Data state mein set kiya
            setLoading(false);  // Loading khatam
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    // Page khulte hi data lao
    useEffect(() => {
        fetchVisas();
    }, []);

    // --- DELETE HANDLER ---
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this visa record?")) {
            try {
                await axios.delete(`${API_BASE_URL}/api/visa/${id}`);
                alert("🗑️ Record Deleted Successfully!");
                fetchVisas(); // List refresh karo delete ke baad
            } catch (error) {
                alert("❌ Error deleting record.");
            }
        }
    };

    // --- SEARCH FILTER LOGIC ---
    const filteredVisas = visas.filter((visa) => 
        visa.referenceNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        visa.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        visa.surname.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // 👇 Passport Search Added
        (visa.passportNumber && visa.passportNumber.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <div className="container mt-5 mb-5">
            {/* --- HEADER SECTION --- */}
            <div className="text-center mb-5">
                <h2 style={{ color: '#003366', fontFamily: 'serif', fontWeight: 'bold' }}>
                    Visa Application Status
                </h2>
                <p className="text-muted">Check your visa details and current status below.</p>
            </div>

            {/* --- SEARCH BAR --- */}
            <div className="row justify-content-center mb-4">
                <div className="col-md-6">
                    <input 
                        type="text" 
                        className="form-control p-3 shadow-sm rounded-pill" 
                        placeholder="🔍 Search by Ref No, Name or Passport No..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            {/* --- LOADING SPINNER --- */}
            {loading ? (
                <div className="text-center mt-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Fetching data from server...</p>
                </div>
            ) : (
                /* --- DATA DISPLAY --- */
                <div className="row">
                    {filteredVisas.length > 0 ? (
                        filteredVisas.map((visa) => (
                            <div className="col-md-6 col-lg-4 mb-4" key={visa._id}>
                                <div className="card shadow-sm h-100 border-0" style={{ transition: '0.3s' }}>
                                    
                                    {/* Card Header (Reference Number) */}
                                    <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                                        <small>Ref:</small>
                                        <strong>{visa.referenceNumber}</strong>
                                    </div>

                                    {/* Card Body */}
                                    <div className="card-body">
                                        <h5 className="card-title text-primary mb-3">
                                            {visa.firstName} {visa.surname}
                                        </h5>
                                        
                                        {/* 👇 PASSPORT NUMBER DISPLAY */}
                                        <div className="mb-2">
                                            <span className="text-muted">Passport No:</span>
                                            <span className="float-end fw-bold text-dark">
                                                {visa.passportNumber || "N/A"}
                                            </span>
                                        </div>

                                        <div className="mb-2">
                                            <span className="text-muted">Country:</span>
                                            <span className="float-end fw-bold">{visa.country}</span>
                                        </div>
                                        <div className="mb-2">
                                            <span className="text-muted">Visa Type:</span>
                                            <span className="float-end">{visa.type}</span>
                                        </div>
                                        <div className="mb-2">
                                            <span className="text-muted">Validity:</span>
                                            <span className="float-end text-success fw-bold">{visa.validity}</span>
                                        </div>
                                        <hr />
                                        
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="badge bg-success rounded-pill px-3 py-2">Active / Valid</span>
                                            
                                            {/* 👇 DELETE BUTTON ADDED HERE */}
                                            <button 
                                                className="btn btn-outline-danger btn-sm" 
                                                onClick={() => handleDelete(visa._id)}
                                                title="Delete Record"
                                            >
                                                <i className="fa fa-trash"></i> Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center mt-4">
                            <h5 className="text-muted">No records found matching "{searchTerm}"</h5>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default VisaPage;